// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Image from '../../../image/image';

// Styles
import BlogPostImageQuoteStyles from './blogPostImageQuote.styles';

export default function BlogPostImageQuote({ layout }) {
  const quote = layout?.quote;
  const attribution = layout?.attribution;

  const image = layout?.image;

  return (
    <BlogPostImageQuoteStyles>
      <div className="left">
        <figure className="image-wrapper">
          <Image image={image} filter={image?.filter} className="image" />
        </figure>
      </div>

      <div className="right">
        <p className="quote">{quote}</p>
        {!!attribution && (
          <h4 className="attribution">&mdash; {attribution}</h4>
        )}
      </div>
    </BlogPostImageQuoteStyles>
  );
}

BlogPostImageQuote.propTypes = {
  layout: PropTypes.shape({
    image: PropTypes.shape({}),
    quote: PropTypes.string,
    attribution: PropTypes.string,
  }),
};

BlogPostImageQuote.defaultProps = {
  layout: {},
};
